import { Alert, Divider, Typography } from "antd";
import { useTranslation } from "react-i18next";

import BatchTransitionFooter from "./batch-transition-footer";
import BatchTransitionForm from "./batch-transition-form";
import BatchTransitionRow from "./batch-transition-row";
import { useBatchTransitionContext } from "./batch-transition.context";

import "./batch-transition.style.less";

const { Paragraph } = Typography;

const BatchTransition = () => {
  const { t } = useTranslation();
  const { type, count, states } = useBatchTransitionContext();

  return (
    <div className="batch-transition">
      <Paragraph>
        <strong>{t("global:batchTransition.title")}</strong>
        <br />
        {t(`${type}:batchTransition.description`, { count })}
      </Paragraph>
      <Alert title={t(`${type}:batchTransition.info`)} type="info" showIcon />
      <Divider />
      {states.map((state) => (
        <BatchTransitionRow
          key={`batch-transition-row-${state}`}
          state={state}
          form={<BatchTransitionForm state={state} />}
        />
      ))}
      <BatchTransitionFooter />
    </div>
  );
};

export default BatchTransition;
